"use client";

import { useTour } from "@/context/TourContext";
import React from "react";

interface TourHighlightProps {
  children: React.ReactNode;
  tourId: string;
  className?: string;
}

export const TourHighlight: React.FC<TourHighlightProps> = ({
  children,
  tourId,
  className = "",
}) => {
  const { tourState } = useTour();
  const currentStep = tourState.steps[tourState.currentStep];
  const isActive =
    tourState.isActive &&
    (currentStep?.target === tourId || currentStep?.secondaryTarget === tourId);

  return (
    <div
      data-tour={tourId}
      className={`${className} ${isActive ? "relative z-[10001]" : ""}`}
    >
      {children}
    </div>
  );
};
